'use strict';

/**
 *
 */
angular.
module('moebiusProadapt').
service('mbsEtiService', ['$rootScope', '$injector', '$http', '$timeout', '$q', 'mbsLookupService', function mplEtiServiceFactory($rootScope, $injector, $http, $timeout, $q, mbsLookupService) {

    this.etisData = {};
    this.currentEti = null;
    this.currentVisite = null;


    //Fetch a service ($inject it if necessary)
    function getService(serviceName){
        return $injector.get(serviceName);
    }

    this.getConfigurationForEti = function(etiId) {
        return this.etisData[etiId];
    };

    /**
     * reset data
     */
    this.init = function ()
    {
        this.currentEti = {id:-1};
        this.currentVisite = {key:null};
        this.currentVisite = null;
        $rootScope.eti = this.currentEti;
        $rootScope.visite = this.currentVisite;
        $rootScope.questionMereKeyShortToKeyLong = {};
    };

    /**
     * @returns Object Eti
     */
    this.setCurrentEti = function (eti) {
        this.currentEti = eti;
        $rootScope.eti = this.currentEti;
    };

    /**
     * @returns Object Eti
     */
    this.getCurrentEti = function () {
        return this.currentEti;
    };

    /**
     * @returns Object Visite
     */
    this.setCurrentVisite = function (visite) {
        if(typeof visite !== 'undefined') {
            if (this.currentEti.etudedefArray.visitesList[visite.key]) {
                this.currentVisite = this.currentEti.etudedefArray.visitesList[visite.key];
            } else {
                this.currentVisite = visite;
            }
            $rootScope.visite = this.currentVisite;
        }
    };

    /**
     * Nécessaire réinitialisation
     */
    this.reinitData = function() {
        if (this.getCurrentEti().id !== -1) {
            _.each(this.currentEti.etudedefArray.questionsVisitesList, function(questionVisiteObject) {
                questionVisiteObject.reinit();
            });
            _.each(this.currentEti.etudedefArray.questionnairesVisitesList, function(questionnaireVisiteObject) {
                questionnaireVisiteObject.reinit();
                questionnaireVisiteObject.updateProgress($rootScope.participant);
            });
        }
    }

    /**
     * @returns Object Visite
     */
    this.getCurrentVisite = function () {
        return this.currentVisite;
    };


    /**
     * load eti and cache questionVisite configurations
     * @param eti
     */
    this.initWithEti = function(eti)
    {
        // -- setup this.getCurrentEti() access
        this.init();
        this.setCurrentEti(eti);
// console.log('this.initWithEti ', $rootScope.eti, this.currentEti, this.currentEti.etudedefArray.questionsVisitesOrderedIds);

        // -- ---------------------------------------
        // -- Enrichissement de l'objet questionVisite
        // -- ---------------------------------------
        // -- ajout de l'interactivité et des règles dynamiques
        // --
        // -- ---> ATTENTION
        // -- ---> ATTENTION
        // -- ---> ATTENTION
        // --
        // -- ---> TOUT CELA EST APPELE UNE SEULE FOIS PAR ETUDE !!! AU BOOTSTRAP DE LA SPA
        // --
        var that = this;
        this.currentEti.etudedefArray.questionsVisitesOrderedIds.forEach(function(questionVisiteId)  {
            var eti                 = this.currentEti;
            var questionVisite      = eti.etudedefArray.questionsVisitesList[questionVisiteId];
            var questionMere        = eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key];
            var questionnaireVisite = null;
            var questionnaireVisiteKey = null;
            if (questionVisite.questionnaire_visite_id) {
                questionnaireVisite     = _.find(eti.etudedefArray.questionnairesVisitesList, {id: questionVisite.questionnaire_visite_id});
                if (questionnaireVisite) {
                    questionnaireVisiteKey  = questionnaireVisite.key;
                }
            }

            // -- drop uniquify part of questionVisite
            $rootScope.questionMereKeyShortToKeyLong[questionMere.key_cross_etude] = questionMere.key;

            var isChoiceFromListeValeur = false;
            if(questionMere.inputType === $rootScope.constants.input_types.NAMES_TO_VALUES.RADIO_BY_IDX
                || questionMere.inputType === $rootScope.constants.input_types.NAMES_TO_VALUES.DROPDOWN_BY_IDX
                || questionMere.inputType === $rootScope.constants.input_types.NAMES_TO_VALUES.SLIDER_BY_IDX
                || questionMere.inputType === $rootScope.constants.input_types.NAMES_TO_VALUES.MULTIPLE_CHECKBOX
            ) {
                isChoiceFromListeValeur = true;
            }

            // // local default local data
            questionVisite.localAttributes = {
                visible         : true,
                placeholder     : (questionMere.inputOptions && questionMere.inputOptions.placeholder) ? questionMere.inputOptions.placeholder : '-',
                resolvedDropDown: isChoiceFromListeValeur ? mbsLookupService.getLookupForEtiByIdentifer(eti.id, questionMere.id) : [],
                dynamicDropDown : isChoiceFromListeValeur ? mbsLookupService.getLookupForEtiByIdentifer(eti.id, questionMere.id) : []
            };
// console.log('********' , questionVisite.localAttributes);
            // -- ------------------
            // -- domain object properties
            // -- ------------------
            questionVisite.isAnwsered = false;
            questionVisite.isDirty    = false;


            // -- ------------------
            // -- domain object méthodes
            // -- ------------------

            /**
             * Réinitialisation de l'état de l'objet
             */
            questionVisite.reinit = function() {
                questionVisite.isAnwsered     = false;
                questionVisite.isDirty        = false;
            };


            questionVisite.setIcon = function(participant) {
                var icon = '';
                if (questionMere.interlocuteur === $rootScope.constants.roles.NAMES_TO_VALUES.patient) {
                    icon = $rootScope.constants.roles.VALUES_TO_NAMES[questionMere.interlocuteur];
                    if (participant.sexe == 584) {
                        icon += '-f';
                    } else {
                        icon += '-m';
                    }
                } else {
                    icon = $rootScope.constants.roles.VALUES_TO_NAMES[questionMere.interlocuteur];
                }
                questionVisite.icon = icon;
            };

            questionVisite.cast = function (participant) {
                var val = participant.getValue(questionVisite);

                if (val) {
                    switch (questionMere.dataType) {
                    case 'date':
                        participant.setValue(questionVisite, new Date(val));
                        break;
                    default:
                        break;
                    }
                }

            };

            //--- travail préparatoire on enriche les observeurs de leur vrai objet questionVisite
            // // consolidate fields relations
            _.each(questionVisite.notification.remote.observers, function(observer) {
                observer.questionVisite = eti.etudedefArray.questionsVisitesList[observer.key];
            });

            _.each(questionVisite.notification.remote.observeds, function(observer) {
                observer.questionVisite = eti.etudedefArray.questionsVisitesList[observer.key];
            });

            // -- QV notifying QRV
            _.each(questionVisite.notification.remote.qrvObservers, function(observer) {
                observer.questionnaireVisite = eti.etudedefArray.questionnairesVisitesList[observer.key];
            });


            _.each(questionVisite.notification.local.observers, function(observer) {
                observer.questionVisite = eti.etudedefArray.questionsVisitesList[observer.key];
            });

            _.each(questionVisite.notification.local.observeds, function(observer) {
                observer.questionVisite = eti.etudedefArray.questionsVisitesList[observer.key];
            });

            // -- QV notifying QRV
            _.each(questionVisite.notification.local.qrvObservers, function(observer) {
                observer.questionnaireVisite = eti.etudedefArray.questionnairesVisitesList[observer.key];
            });


            // callback loop for each remote notify
            questionVisite.notification.remote.notify = function(questionVisite, visite, participant, currentValue, previousValue)
            {
                var promises = [];
                _.each(questionVisite.notification.remote.notifications, function(notifyCallback)
                {
                    promises.push(notifyCallback(questionVisite, visite, participant, currentValue, previousValue));
                });

                // -- QRV observing QV
                _.each(questionVisite.notification.remote.qrvNotifications, function(notifyCallback)
                {
                    notifyCallback(questionnaireVisite, visite, participant, currentValue, previousValue);
                });

                return $q.all(promises);
            };

            // callback loop for each local notify
            questionVisite.notification.local.notify = function(questionVisite, visite, participant, currentValue, previousValue)
            {

// if ([3816 ,3818, 43,21].indexOf(questionVisite.id) !== -1) {
//     console.log('From eti, questionVisite.notification.local.notify : qv key ' + questionVisite.id + ' contains ' + questionVisite.notification.local.notifications.length + ' callback !');
// }
                _.each(questionVisite.notification.local.notifications, function(notifyCallback)
                {
                    //--- on définit que si qv est notifiée, alors elle va elle même appeler toutes les functions enregistrées dans local.notifications
                    notifyCallback(questionVisite, visite, participant, currentValue, previousValue);
                });

                // -- QRV observing QV
                _.each(questionVisite.notification.local.qrvNotifications, function(notifyCallback)
                {
                    notifyCallback(questionnaireVisite, visite, participant, currentValue, previousValue);
                });
            };

            // callbacks
            questionVisite.notification.remote.notifications = [];
            questionVisite.notification.local.notifications = [];

            questionVisite.localAttributes.visible = questionMere.isVisible;

            // // Resolve all callback for each questionVisites

            // LOCAL Notification
            // └> setup local notification callback for local formulas
            _.each(questionVisite.notification.local.observers, function(observer) {
                // FormulaVisible
                if (observer.formula === "FormulaVisible") {

                    //TODO : alert si une notification est push alors qu'elle ne devrait pas (oberver pas supprimé comme il faut en fonction de is_optimized)
                    // WIP
                    // if(($rootScope.participant.is_optimized && questionVisite.available_for_participant==$rootScope.constants.available_for_participant.NAMES_TO_VALUES.not_optimized) || (!$rootScope.participant.is_optimized && questionVisite.available_for_participant==$rootScope.constants.available_for_participant.NAMES_TO_VALUES.optimized)) {
                    //     console.log("ALERT!",questionVisite.localAttributes.visible,$rootScope.participant.is_optimized);
                    // }
                    questionVisite.notification.local.notifications.push(function (questionVisite, visite, participant) {

// if ([43,3816,3818,21].indexOf(questionVisite.id) !== -1) {
//     console.log('OBSERVEE qv key ' + questionVisite.id);
// }
                        // console.log(observers);
                        // perform FormulaVisible for each Observer
                            var formulas = _.filter(observer.questionVisite.notification.local.observeds, {formula: 'FormulaVisible'});
                            var isVisible = true;

                            // search for values and condition
                            _.find(formulas, function (formula) {
                                var value   = participant.getValue(formula.questionVisite);

                                // var service = formula.options.service;
                                // var service = formula.options.qmObservedValue;

                                switch (formula.options.service) {
                                    case 'qmIsEqualTo':
                                        if (value === null) {
                                            isVisible = false;
                                        } else {
                                            isVisible = formula.options.qmObservedValue === value;
                                        }
                                        break;
                                    case 'qmIsGreaterOrEqualThan':
                                        if (value === null || (typeof observer.questionVisite !== "undefined" && typeof eti.etudedefArray.questionsMeresList[observer.questionVisite.question_mere_key] !== "undefined" && eti.etudedefArray.questionsMeresList[observer.questionVisite.question_mere_key].isVisible === false)) {
                                            isVisible = false;
                                        } else {
                                            isVisible = value >= formula.options.qmObservedValue;
                                        }
                                        break;
                                    default:
                                        console.log('condition "' + formula.options.service + '" not implemented for FormulaVisible');
                                        break;
                                }

                                if (!isVisible) {
                                    return true; // break;
                                }
                            });

                            // the questionVisite Is hidden, reset his value ONLY if it is a QV CONDITIONALY VISIABLE
                            // Date and Score and raison non rempli sont des QV qui ne sont jamais visibles, elles ne sont donc jamais reseté
                            if (eti.etudedefArray.questionsMeresList[observer.questionVisite.question_mere_key].isVisible !== false && !isVisible) {
                                // -- Grand méchant Bug
                                participant.setValue(observer.questionVisite, null);
                            }
// if ([43,3816].indexOf(observer.questionVisite.id) !== -1) {
// console.log(' qv key ' + observer.questionVisite.id + ' isVisible ' + isVisible);
// }
                            observer.questionVisite.localAttributes.visible = isVisible;
                    });
                }

                // -- FormulaRequired
                else if(observer.formula === "FormulaRequired")
                {
                    questionVisite.notification.local.notifications.push(function(questionVisite, visite, participant, previousManualValue, currentManualValue) {
                        var participantVisite    = participant.participantStepsByStepKey[visite.key];
                        var currentAutoValue = participant.participantValuesByQuestionVisiteId[questionVisite.id].auto;

                        if(!participantVisite.error_is_not_allowed_to_be_submitted) {
                            participantVisite.error_is_not_allowed_to_be_submitted = {};
                        }

                        var previousWasNull   = _.isNull(previousManualValue) || _.isUndefined(previousManualValue) || (previousManualValue === '');
                        var currentIsNull     = _.isNull(currentManualValue)  || _.isUndefined(currentManualValue)  || (currentManualValue  === '');
                        var currentAutoIsNull = _.isNull(currentAutoValue)    || _.isUndefined(currentAutoValue)    || (currentAutoValue    === '');

                        var manualHasBeenRemoved = (!previousWasNull &&  currentIsNull);
                        var manualHasBeenSet     = ( previousWasNull && !currentIsNull);
                        var hasValidAutoValue    = (!!questionVisite.isQuestionVisiteDual && !currentAutoIsNull);

                        // This field had value and is now empty
                        if(manualHasBeenRemoved && !hasValidAutoValue) {
                            participantVisite.error_is_not_allowed_to_be_submitted[questionVisite.id] = questionVisite.name+' est obligatoire';
                        }
                        // A value is entered when this field was empty
                        else if(manualHasBeenSet) {
                            delete participantVisite.error_is_not_allowed_to_be_submitted[questionVisite.id];
                        }

                        // update submit status
                        participantVisite.is_allowed_to_be_submitted = _.isEmpty(participantVisite.error_is_not_allowed_to_be_submitted);
                    });
                }
            });



            // REMOTE Notification
            // └> pull a new object from the server to evaluate the data when formula are complexe
            if(questionVisite.notification.remote.observers.length > 0)
            {
                questionVisite.notification.remote.notifications.push(function(questionVisite, visite, participant)
                {

                    participant.remoteNoSaveOneQuestionVisite(questionVisite.id, questionnaireVisiteKey);

                });
            }



            // --------------------------
            // QV TO QRV NOTIFICATION
            // --------------------------

            questionVisite.notification.local.qrvNotifications = [];
            questionVisite.notification.remote.qrvNotifications = [];

            // └> setup local notification callback for local formulas
            _.each(questionVisite.notification.local.qrvObservers, function(observer) {
                // FormulaVisible
                if (observer.formula === "FormulaVisible") {

                    var questionnaireVisiteWhoObserve = observer.questionnaireVisite;

                    //TODO : alert si une notification est push alors qu'elle ne devrait pas (oberver pas supprimé comme il faut en fonction de is_optimized)

                    questionVisite.notification.local.qrvNotifications.push(function (questionnaireVisiteWhoObserve, visite, participant) {
                        //console.log('FormulaVisible called for questionVisite', questionVisite.name);
                        var observers = _.filter(questionVisite.notification.local.qrvObservers, {formula: 'FormulaVisible'});

                        // perform FormulaVisible for each Observer
                        _.each(observers, function (qrvObserver) {
                            var formulas = _.filter(qrvObserver.questionnaireVisite.qvNotification.local.qvObserveds, {formula: 'FormulaVisible'});
                            var isVisible = true;

                            // search for values and condition
                            _.find(formulas, function (formula) {
                                var value   = participant.getValue(formula.questionVisite);

                                // var service = formula.options.service;
                                // var service = formula.options.qmObservedValue;

                                switch (formula.options.service) {
                                    case 'qmIsEqualTo':
                                        if (value === null) {
                                            isVisible = false;
                                        } else {
                                            isVisible = formula.options.qmObservedValue === value;
                                        }
                                        break;
                                    case 'qmIsGreaterOrEqualThan':
                                        if (value === null || (typeof observer.questionVisite !== "undefined" && typeof eti.etudedefArray.questionsMeresList[observer.questionVisite.question_mere_key] !== "undefined" && eti.etudedefArray.questionsMeresList[observer.questionVisite.question_mere_key].isVisible === false)) {
                                            isVisible = false;
                                        } else {
                                            isVisible = value >= formula.options.qmObservedValue;
                                        }
                                        break;
                                    default:
                                        console.log('condition "' + formula.options.service + '" not implemented for FormulaVisible');
                                        break;
                                }

                                if (!isVisible) {
                                    return true; // break;
                                }
                            });


                            // console.log(' qv key ' + observer.questionVisite.id + ' isVisible ' + isVisible);

                            observer.questionnaireVisite.localAttributes.visible = isVisible;
                        });
                    });
                }
            });

            // REMOTE Qrv Notification
            // └> pull a new object from the server to evaluate the data when formula are complexe
            if(questionVisite.notification.remote.qrvObservers.length > 0)
            {
                questionVisite.notification.remote.qrvNotifications.push(function(questionVisite, visite, participant)
                {


                    participant.remoteNoSaveOneQuestionVisite(questionVisite.id, questionnaireVisiteKey);

                });
            }

        }, this);


        // -- ---------------------------------------
        // -- Enrichissement de l'objet Visite
        // -- ---------------------------------------
        // that = this;
        _.each(this.currentEti.etudedefArray.visitesList, function(visite)  {
            visite.getQuestionnairesVisites = function() {
                var that = this;
                var qrvIds = _.filter(this.questionnairesVisitesOrderedKeys, function(qrvKey) {
                    if (eti.etudedefArray.questionnairesVisitesList[qrvKey].visite_key === that.key) {
                        return true;
                    }
                    return false;
                });
                var qrvObjects = [];
                _.each(qrvIds, function(qrvId) {
                    qrvObjects.push(eti.etudedefArray.questionnairesVisitesList[qrvId]);
                });
                return qrvObjects
            };

            visite.getQuestionnaires = function() {
                var that = this;
                var qrvIds = _.filter(this.questionnairesVisitesOrderedKeys, function(qrvKey) {
                    if (eti.etudedefArray.questionnairesVisitesList[qrvKey].visite_key === that.key) {
                        return true;
                    }
                    return false;
                });
                var qrvObjects = [];
                _.each(qrvIds, function(qrvId) {
                    qrvObjects.push(eti.etudedefArray.questionnairesList[eti.etudedefArray.questionnairesVisitesList[qrvId].questionnaire_key]);
                });
                return qrvObjects
            };

            visite.getQuestionnairesVisitesForOnglet = function(onglet) {
                var qrvIds = _.filter(this.questionnairesVisitesOrderedKeys, function(qrvKey) {

                    // -- @todo REMOVE THIS ONCE WE LAUNCH JALON2
                    //  @todo : TANT QUE Jalon2 n'est pas en prod, on exclus StoppStart et ConciliationMedicamenteuse
                    if ( ! $rootScope.globalParams.moebiusMode
                        && [
                            'PILOT1__QRV_V__V1_QR__STOPP_START',
                            'PILOT1__QRV_V__V1_QR__TRAITEMENT_CONCILIATION_MEDICAMENTEUSE'
                        ].indexOf(qrvKey) !== -1) {
                            return false;
                    }

                    if (eti.etudedefArray.questionnairesVisitesList[qrvKey].onglet_id === onglet.id) {
                        return true;
                    }
                    return false;
                });
                var qrvObjects = [];
                _.each(qrvIds, function(qrvId) {
                    qrvObjects.push(eti.etudedefArray.questionnairesVisitesList[qrvId]);
                });
                return qrvObjects
            };

            visite.getQuestionnairesForOnglet = function(onglet) {
                var qrvIds = _.filter(this.questionnairesVisitesOrderedKeys, function(qrvKey) {
                    if (eti.etudedefArray.questionnairesVisitesList[qrvKey].onglet_id === onglet.id) {
                        return true;
                    }
                    return false;
                });
                var qrvObjects = [];
                _.each(qrvIds, function(qrvId) {
                    qrvObjects.push(eti.etudedefArray.questionnairesList[eti.etudedefArray.questionnairesVisitesList[qrvId].questionnaire_key]);
                });
                return qrvObjects
            };


            visite.getQuestionVisiteForQuestionMereKeyLong = function(qmKeyLong) {
                var qvId;
                if (qmKeyLong &&
                    eti.etudedefArray.questionsMeresList[qmKeyLong] &&
                    eti.etudedefArray.questionsMeresList[qmKeyLong].relatedQuestionsVisitesIds &&
                    eti.etudedefArray.questionsMeresList[qmKeyLong].relatedQuestionsVisitesIds[this.key])
                {
                    qvId =  eti.etudedefArray.questionsMeresList[qmKeyLong].relatedQuestionsVisitesIds[this.key];
                    return eti.etudedefArray.questionsVisitesList[qvId];
                } else {
                    return null;
                }
            };

            visite.getQuestionVisiteForQuestionMereKeyShort = function(qmKeyShort) {
                var qmKeyLong = $rootScope.questionMereKeyShortToKeyLong[qmKeyShort];
                if (!qmKeyLong) {
                    console.log('NOT READ FOR ' + qmKeyShort);
                }else {
                    // console.log('GOT '+qmKeyLong+' FOR ' + qmKeyShort);
                }
                return this.getQuestionVisiteForQuestionMereKeyLong(qmKeyLong);
            };

            visite.getQuestionVisiteForQuestionMereKeyList = function(qmKeyLong) {
                var qvs = {};
                if (qmKeyLong &&
                    eti.etudedefArray.questionsMeresList[qmKeyLong] &&
                    eti.etudedefArray.questionsMeresList[qmKeyLong].relatedQuestionsVisitesIds)
                {
                    _.each(eti.etudedefArray.questionsMeresList[qmKeyLong].relatedQuestionsVisitesIds,function(value,key){
                        qvs[key] = eti.etudedefArray.questionsVisitesList[value];
                    });
                    return qvs;
                } else {
                    return null;
                }
            };

        });


        // -- ---------------------------------------
        // -- Enrichissement de l'objet Questionnaire
        // -- ---------------------------------------
        _.each(this.currentEti.etudedefArray.questionnairesList, function(questionnaire) {

            questionnaire.getQuestionnairesVisites = function() {
                var that = this;
                var qrvObjects = _.filter(eti.etudedefArray.questionnairesVisitesList, function (questionnaireVisite) {
                    if (questionnaireVisite.questionnaire_key === that.key) {
                        return true;
                    }
                    return false;
                });
                return qrvObjects
            };

            questionnaire.getQuestionnaireVisiteOfVisite = function(visiteKey) {
                var that = this;
                var qrvObjects = _.filter(this.getQuestionnairesVisites(), function (questionnaireVisite) {
                    if (questionnaireVisite.visite_key === visiteKey) {
                        return true;
                    }
                    return false;
                });
                return qrvObjects[0]
            };

            questionnaire.getQuestionsMeres = function() {
                var that = this;
                var qmObjects = _.filter(eti.etudedefArray.questionsMeresList, function (questionMere) {
                    if (questionMere.questionnaire_key === that.key) {
                        return true;
                    }
                    return false;
                });
                return qmObjects
            };

            questionnaire.nombreQuestionnairesVisites = questionnaire.getQuestionnairesVisites().length;
            questionnaire.nombreQuestionsMeres        = questionnaire.getQuestionsMeres().length;
        });




        // -- ---------------------------------------
        // -- Enrichissement de l'objet QuestionnaireVisite
        // -- ---------------------------------------
        _.each(this.currentEti.etudedefArray.questionnairesVisitesList, function(questionnaireVisite) {

            // -- ------------------
            // -- domain object properties
            // -- ------------------

            questionnaireVisite.isDirty     = false;
            questionnaireVisite.progression = 0;
            questionnaireVisite.liveProgression = 0;

            questionnaireVisite.localAttributes = {
                visible: false,
            };


            // -- ------------------
            // -- Notify
            // -- ------------------
            _.each(questionnaireVisite.qvNotification.local.qvObserveds, function(observer) {
                observer.questionVisite = eti.etudedefArray.questionsVisitesList[observer.key];
            });

            // -- ------------------
            // -- domain object méthodes
            // -- ------------------
            /**
             * Réinitialisation de l'état de l'objet
             */
            questionnaireVisite.reinit = function() {
                questionnaireVisite.isDirty     = false;
                questionnaireVisite.progression = 0;
                questionnaireVisite.liveProgression = 0;
            };

            questionnaireVisite.getQuestionnaire = function() {
                return eti.etudedefArray.questionnairesList[this.questionnaire_key];
            };

            questionnaireVisite.questionVisiteScore = null;
            if (questionnaireVisite.getQuestionnaire() && questionnaireVisite.getQuestionnaire().questionmerescore_key) {
                questionnaireVisite.questionVisiteScore                         = eti.etudedefArray.visitesList[questionnaireVisite.visite_key].getQuestionVisiteForQuestionMereKeyLong(questionnaireVisite.getQuestionnaire().questionmerescore_key);
            }

            questionnaireVisite.questionVisiteDate  = null;
            if (questionnaireVisite.getQuestionnaire() && questionnaireVisite.getQuestionnaire().questionmeredate_key) {
                questionnaireVisite.questionVisiteDate                         =  eti.etudedefArray.visitesList[questionnaireVisite.visite_key].getQuestionVisiteForQuestionMereKeyLong(questionnaireVisite.getQuestionnaire().questionmeredate_key);
                questionnaireVisite.questionVisiteDate.localAttributes.visible = false;
            }

            questionnaireVisite.questionVisiteRaisonNonRempli  = null;
            if (questionnaireVisite.getQuestionnaire() && questionnaireVisite.getQuestionnaire().questionmereraisonnonrempli_key) {
                questionnaireVisite.questionVisiteRaisonNonRempli                         =  eti.etudedefArray.visitesList[questionnaireVisite.visite_key].getQuestionVisiteForQuestionMereKeyLong(questionnaireVisite.getQuestionnaire().questionmereraisonnonrempli_key);
                questionnaireVisite.questionVisiteRaisonNonRempli.localAttributes.visible = false;
            }

            // questionnaireVisite.getManuQuestionsVisites        = function() {
            //     return _.filter(questionnaireVisite.questionsVisitesOrderedIds, function(qvKey) {
            //         return eti.etudedefArray.questionsVisitesList[qvKey].overwritePriority === 'manu';
            //     });
            // };


            questionnaireVisite.getUnansweredQuestionVisiteIds = function(participant) {

                if (participant && participant.id > 0) {
                    return _.filter(questionnaireVisite.questionsVisitesOrderedIds, function(qvKey) {
                        var questionVisite = eti.etudedefArray.questionsVisitesList[qvKey];
                        var questionMere = eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key];
                        // -- unanswered ET visible ET non nd

                        if ( ! participant.participantValuesByQuestionVisiteId[questionVisite.id]) {
                            console.error('********* STRUCTURE: ' +  questionVisite.question_mere_key + ' n\'existe pas pour ce participant et cette visite ');
                            return;
                        }

                        /*
                        210223_6 Bug comptage de la valeur de auto
                        if (eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key].dataType === $rootScope.constants.data_types.NAMES_TO_VALUES.LINKED_TABLE) {
                            console.log('!!!'  + questionMere.key_cross_etude + ' has auto=' + participant.participantValuesByQuestionVisiteId[questionVisite.id].auto + ' et ND=' +  participant.participantValuesByQuestionVisiteId[questionVisite.id].nd);
                        }*/


                        // -- linked Table
                        if (
                            eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key].dataType === $rootScope.constants.data_types.NAMES_TO_VALUES.LINKED_TABLE &&
                            ( (participant.participantValuesByQuestionVisiteId[questionVisite.id].auto && participant.participantValuesByQuestionVisiteId[questionVisite.id].auto > 0) || participant.participantValuesByQuestionVisiteId[questionVisite.id].nd === 1)
                        ) {
                            return false;
                        }

                        return (participant.getValue(questionVisite) === null
                            && questionVisite.overwritePriority === "manu"
                            && questionVisite.localAttributes.visible === true
                            && participant.participantValuesByQuestionVisiteId[questionVisite.id].nd === 0
                            && participant.participantValuesByQuestionVisiteId[questionVisite.id].is_hidden !== 1
                        )
                    });
                } else {
                    return questionnaireVisite.questionsVisitesOrderedIds;
                }
            };


            questionnaireVisite.updateProgress = function(participant) {
                var res         = 0;
                var total       = 0;
                var unanswered  = 0;
                var answered    = 0;
                if (!questionnaireVisite.questionsVisitesOrderedIds) {
                    res = 100;
                } else {
                    //pour linked_table : on verifie la value auto, qui contient le count
                    var qvHasLinkedTable = _.filter(questionnaireVisite.questionsVisitesOrderedIds, function(qvKey) {
                        var questionVisite = eti.etudedefArray.questionsVisitesList[qvKey];
                        if (
                            eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key].dataType === $rootScope.constants.data_types.NAMES_TO_VALUES.LINKED_TABLE) {
                            return true;
                        }
                    }).length;

                    // -- cas deq QRV contenant un tableau
                    if(qvHasLinkedTable>0){
                        // -- que les manuels
                        total = _.filter(questionnaireVisite.questionsVisitesOrderedIds, function (qvKey) {
                            var questionVisite = eti.etudedefArray.questionsVisitesList[qvKey];
                            // console.log(eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key].dataType, participant.participantValuesByQuestionVisiteId[questionVisite.id]['auto']);
                            if (participant && participant.participantValuesByQuestionVisiteId && participant.participantValuesByQuestionVisiteId[questionVisite.id] && participant.participantValuesByQuestionVisiteId[questionVisite.id].is_hidden === 1) {
                                return false;
                            }
                            else if (questionVisite.overwritePriority === "manu" && questionVisite.localAttributes.visible) {

                                return true;
                            }
                        });
                        if (total && total.length > 0) {
                            total = total.length;
                        }
                        unanswered = questionnaireVisite.getUnansweredQuestionVisiteIds(participant).length;
                        answered = total - unanswered;
                        res = answered * 100 / total;

                        // console.log(res);
                    }
                    // -- les autres QRV
                    else {
                        // -- que les manuels
                        total = _.filter(questionnaireVisite.questionsVisitesOrderedIds, function (qvKey) {
                            var questionVisite = eti.etudedefArray.questionsVisitesList[qvKey];
                            // console.log(eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key].dataType, participant.participantValuesByQuestionVisiteId[questionVisite.id]['auto']);
                            if (participant && participant.participantValuesByQuestionVisiteId && participant.participantValuesByQuestionVisiteId[questionVisite.id] && participant.participantValuesByQuestionVisiteId[questionVisite.id].is_hidden === 1) {
                                return false;
                            }
                            else if (questionVisite.overwritePriority === "manu" && questionVisite.localAttributes.visible) {

                                return true;
                            }
                        });
                        if (total && total.length > 0) {
                            total = total.length;
                        }

                        unanswered = questionnaireVisite.getUnansweredQuestionVisiteIds(participant).length;
                        answered = total - unanswered;
                        res = answered * 100 / total;
                    }
                }
                questionnaireVisite.progression = Math.round(res);
               //console.log(questionnaireVisite.id + ' progression ' + questionnaireVisite.progression + ' for res ' + res + '( ' + answered + ' / ' + total + ' ) ' );
            };

            questionnaireVisite.updateLiveProgress = function() {
                console.log('updateLiveProgress');
                var res         = 0;
                var total       = 0;
                var answered    = 0;
                if (!questionnaireVisite.questionsVisitesOrderedIds) {
                    res = 100;
                } else {
                    // -- que les manuels
                    total       = _.filter(questionnaireVisite.questionsVisitesOrderedIds, function(qvKey) {
                        var questionVisite = eti.etudedefArray.questionsVisitesList[qvKey];
                        return  questionVisite.overwritePriority === "manu" && questionVisite.localAttributes.visible === true;
                    });

                    // -- repondus = ANSWER_IS_DIRTY || ANSWER_SAVED
                    answered    = _.filter(total, function(qvKey) {
                        var questionVisite = eti.etudedefArray.questionsVisitesList[qvKey];
                        return questionVisite.stateAnswerAndSave === 'ANSWERED_DIRTY' || questionVisite.stateAnswerAndSave === 'ANSWERED_SAVED';
                    });
                    if (answered && answered.length>0) {
                        answered = answered.length;
                    }
                    if (total && total.length>0) {
                        total = total.length;
                    }
                    res         = answered*100/total;
                }
                questionnaireVisite.liveProgression = Math.round(res);
            };

            questionnaireVisite.updateIsDirty = function() {
                var hasIsDirty = false;

                questionnaireVisite.questionsVisitesOrderedIds.forEach(function(qvKey) {
                    if (eti.etudedefArray.questionsVisitesList[qvKey].isDirty) {
                        hasIsDirty = true;
                    }
                });

                questionnaireVisite.isDirty = hasIsDirty;
            };


            // -- display name surchargeable
            questionnaireVisite.displayName = questionnaireVisite.name;
            if (!questionnaireVisite.displayName && questionnaireVisite.getQuestionnaire() && questionnaireVisite.getQuestionnaire().name) {
                questionnaireVisite.displayName = questionnaireVisite.getQuestionnaire().name;
            }

            // -- bootstrap
            questionnaireVisite.updateProgress($rootScope.participant);
        });

        // Resolve all callback for each questionVisites
/*
            // REMOTE Notification
            // └> pull a new object from the server to evaluate the data when formula are complexe
            if(questionVisite.notification.remote.observers.length > 0)
            {
                questionVisite.notification.remote.notifications.push(function(questionVisite, step, candidate)
                {
                    var candidateId = candidate.id       ? '/' + candidate.id : '/new';
                    var payload     = {
                        candidateValuesByQuestionVisiteId: candidate.candidateValuesByQuestionVisiteId,
                    };

                    switch(this.currentEti.etudedefArray.adderPolicy)
                    {
                        case $rootScope.constants.workflow.policy.add.APPLE_ID:
                            payload.appleIds = candidate.apple_id ? [candidate.apple_id] : null;
                            break;

                        case $rootScope.constants.workflow.policy.add.SFO_ID:
                            payload.sfoIds = candidate.sfo_id ? [candidate.sfo_id] : null;
                            break;
                    }

                    // -- it is important to send All questionVisites since several could have been modified
                    var promise = $http.post( 'eti/change-observed-questionVisite-callback/' + eti.id + '/' + step.key + candidateId, payload);

                    promise.then(function(responseObject) {
                        angular.extend(candidate, responseObject.data.candidate);
                    });

                    return promise;
                });
            }

        });
*/
    };

    this.isLoadedEti = function (etiId) {
        return ! angular.isUndefined(this.etisData[etiId]);
    };

    this.storeData = function(data) {
        angular.forEach(data, function(value, etiId) {
            this.etisData[etiId] = value;
        }, this);
    };

    this.getUnansweredQvOfFirstOnglet = function(participant) {
        var firstOnglet  = this.currentEti.etudedefArray.ongletsList[this.currentVisite.ongletsOrderedIds[0]];
        var qrvForOnglet = this.getCurrentVisite().getQuestionnairesVisitesForOnglet(firstOnglet)
        return qrvForOnglet;
    }
    // this.services = function() {
    //     return {
    //         getUnansweredQvOfOnglet1: function() {}
    //     }
    // }
}]);




// WEBPACK FOOTER //
// ./resources/assets/js/services/mbs-eti-service.js